import { render, staticRenderFns } from "./CreateEventPage.vue?vue&type=template&id=21e9a801&scoped=true"
import script from "./CreateEventPage.vue?vue&type=script&lang=ts"
export * from "./CreateEventPage.vue?vue&type=script&lang=ts"
import style0 from "./CreateEventPage.vue?vue&type=style&index=0&id=21e9a801&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e9a801",
  null
  
)

export default component.exports